module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logo_banner/image 020-934ded53f0e51cb16b5bf99361bf021d.png";